import { render, staticRenderFns } from "./RegisterAndLogin.vue?vue&type=template&id=40f8208d&scoped=true&"
import script from "./RegisterAndLogin.vue?vue&type=script&lang=js&"
export * from "./RegisterAndLogin.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAndLogin.vue?vue&type=style&index=0&id=40f8208d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f8208d",
  null
  
)

export default component.exports